(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["harlo-advertorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('harlo-advertorial')) {
  customElements.define('harlo-advertorial', class extends HTMLElement {
    connectedCallback() {
      const sticky = this.querySelector('[data-ha-sticky]');
      const hero = this.querySelector('[data-ha-hero-actions]');
      const close = this.querySelector('[data-ha-close-action]');
      if (!sticky || !hero || !close || !('IntersectionObserver' in window)) return;
      let pastHero = false;
      let closeVisible = false;
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.target === hero) pastHero = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
          if (entry.target === close) closeVisible = entry.isIntersecting;
        });
        sticky.hidden = !pastHero || closeVisible;
      }, { threshold: 0 });
      this.observer.observe(hero);
      this.observer.observe(close);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["harlo-conversion-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('harlo-purchase-return')) {
  customElements.define('harlo-purchase-return', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.error = this.querySelector('.hc-purchase-error');
      this.purchase = document.querySelector('.harlo-pdp .product-form__submit');
      if (!this.button || !this.purchase || !('IntersectionObserver' in window)) return;
      this.form = this.purchase.closest('product-form');
      this.sync = () => {
        const busy = this.purchase.disabled || this.purchase.getAttribute('aria-disabled') === 'true' || this.purchase.classList.contains('loading');
        this.button.disabled = busy;
        this.button.setAttribute('aria-busy', String(this.purchase.classList.contains('loading')));
        const source = this.form?.querySelector('.product-form__error-message-wrapper');
        const message = source && !source.hidden ? source.querySelector('.product-form__error-message')?.textContent.trim() : '';
        this.error.textContent = message || '';
        this.error.hidden = !message;
      };
      this.onBuy = () => {
        this.sync();
        if (this.button.disabled) return;
        this.button.disabled = true;
        this.purchase.click();
        this.sync();
      };
      this.button.addEventListener('click', this.onBuy);
      this.sync();
      this.stateObserver = new MutationObserver(this.sync);
      this.stateObserver.observe(this.form || this.purchase, { attributes: true, childList: true, characterData: true, subtree: true });
      this.observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        this.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
      }, { threshold: 0 });
      this.observer.observe(this.purchase);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.stateObserver?.disconnect();
      this.button?.removeEventListener('click', this.onBuy);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["harlo-hybrid-intro"] && !Shopify.designMode) return;
  try {
    
  if (!window.harloHybridOfferScrollBound) {
    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-harlo-offer-link]');
      if (!link) return;
      var offer = document.querySelector('[id^="MainProduct-"]');
      if (!offer) return;
      event.preventDefault();
      offer.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    window.harloHybridOfferScrollBound = true;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.nav = document.querySelector('header')
      this.announcement = document.querySelector('.new-announcement-bar')
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        // this.nav.classList.add('scrolled-past-nav')
        // this.announcement.classList.add('scrolled-past-announcement')
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        // this.nav.classList.add('scrolled-past-nav')
        // this.announcement.classList.add('scrolled-past-announcement')
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        // this.announcement.classList.remove('scrolled-past-announcement')
        // this.nav.classList.remove('scrolled-past-nav')
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
